import { APICore } from './apiCore'

const api = new APICore()

function getPeriodSurveys (params) {
  const baseUrl = '/period-survey'
  return api.get(baseUrl, params)
}

function getPeriodSurvey (id) {
  const baseUrl = `/period-survey/${id}`
  return api.get(baseUrl, {})
}

function addPeriodSurvey (params) {
  const baseUrl = '/period-survey'
  return api.create(baseUrl, params)
}

function updatePeriodSurvey (params) {
  const baseUrl = '/period-survey'
  return api.update(baseUrl, params)
}

function deletePeriodSurvey (params) {
  const baseUrl = '/period-survey'
  return api.delete(baseUrl, params)
}

export { getPeriodSurveys, getPeriodSurvey, addPeriodSurvey, updatePeriodSurvey, deletePeriodSurvey }
